import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const storedCategories = JSON.parse(localStorage.getItem('catId') || '[]');

// Create a flat object like: { MOVIE: "id123", TV_SHOWS: "id456" }
const categoryMap = storedCategories.reduce((acc, cat) => {
  if (!cat || !cat.title) return acc;
  const key = cat.title.toUpperCase().replace(/\s+/g, '_');
  acc[key] = cat._id;
  return acc;
}, {});

// Optionally define ROUTEs for known categories
const ROUTES = {
  MOVIE: 'movie',
  TV: 'tvn',
  GAME: 'game',
  ONLINE_LEARNING: 'online-learning',
  ARTICLE: 'article',
  // ...add any known slugs here
};

// Build the final Category object
export const Category = Object.keys(categoryMap).reduce((acc, key) => {
  const route = ROUTES[key];
  acc[key] = route ? { ID: categoryMap[key], ROUTE: route } : categoryMap[key]; // If no route, just the ID

  return acc;
}, {});

export const getGeneralCategory = (url) => url.localeCompare('/education');

export const SERVER_URL = process.env.REACT_APP_API_URI;
export const RAWGIO_KEY = process.env.REACT_APP_RAWGIO_API_KEY;
export const TMDB_KEY = process.env.REACT_APP_TMDB_API_KEY;
export const RouteCategory = {};
